import {
  clientIdColumnDefinition,
  conversionRateSource,
  nameColumnDefinition,
  shortNameColumnDefinition,
  legalEntitiesSource,
  companyCodesSource,
  countryCodesSource,
  enabledFlagColumnDefinition,
  maintenanceFlagColumnDefinition,
  emailDomainColumnDefinition,
  supportEmailColumnDefinition,
  notificationEmailColumnDefinition,
  reportFolderColumnDefinition,
  DBLogDetailColumnDefinition,
  fiscalStartMonthDefinition,
  pwcClientIdColumnDefinition,
  pwcEngagementIdColumnDefinition,
  istClientIdColumnDefinition,
  cesClientPridColumnDefinition,
  startPeriodColumnDefinition,
  clientStatusColumnDefinition,
} from '../columnDefinitions';
import { clientFlagCheckboxControlsFactory } from '../columnDefinitionGenerators';

export const columnDefinitions = featureFlags => [
  clientIdColumnDefinition,
  nameColumnDefinition,
  shortNameColumnDefinition,
  clientStatusColumnDefinition,
  { ...enabledFlagColumnDefinition, headerName: 'Enabled' },
  maintenanceFlagColumnDefinition,
  conversionRateSource,
  legalEntitiesSource,
  companyCodesSource,
  countryCodesSource,
  emailDomainColumnDefinition,
  supportEmailColumnDefinition,
  notificationEmailColumnDefinition,
  reportFolderColumnDefinition,
  DBLogDetailColumnDefinition,
  fiscalStartMonthDefinition,
  pwcClientIdColumnDefinition,
  pwcEngagementIdColumnDefinition,
  istClientIdColumnDefinition,
  cesClientPridColumnDefinition,
  startPeriodColumnDefinition,
  ...featureFlags.map(featureFlag => clientFlagCheckboxControlsFactory(featureFlag)),
];
